<template>
  <div class="checkbox" :class="{ 'checked': modelValue }" @click="toggle">
    <span class="checkbox__el"><span class="icon fi-rr-check"></span></span>
    <p>{{ label }}</p>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    modelValue: Boolean,
    label: String
  },
  methods: {
    toggle() {
      this.$emit('update:modelValue', !this.modelValue)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.checkbox{
  width: auto;
  cursor: pointer;
  line-height: 20px;
  background-color: lighten($primary, 5%);
  padding: 10px 15px 10px 10px;
  @include radius(5px);


  &.checked{
    span.checkbox__el{
      background-color: $primary;
      color: $white;
      @include radius(10px);

      span.icon{
        opacity: 1;
      }
    }
  }

  span.checkbox__el{
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    background: $white;
    border: 2px solid $white;
    text-align: center;
    line-height: 20px;
    margin-right: 10px;
    font-size: 10px;
    font-weight: $fontBold;
    @include box-sizing();
    @include transition();
    @include radius(3px);

    span.icon{
      display: inline-block;
      opacity: 0;
      @include transform(translateY(-1px));
      @include transition();
    }
  }

  p{
    display: inline-block;
    font-size: px2rem(14px);
    color: $white;
    width: auto;

    @include responsive(mobile){
      font-size: px2rem(12px);
    }
  }
}
</style>
